import { create } from 'zustand';
import { AuthState } from '../types';

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  errorMessage: undefined,

  login: async (username: string, password: string) => {
    set({ errorMessage: undefined });
    
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (username === 'admin' && password === '123') {
      set({ isAuthenticated: true, errorMessage: undefined });
      return true;
    } else {
      set({ 
        isAuthenticated: false, 
        errorMessage: 'Invalid username or password' 
      });
      return false;
    }
  },

  logout: () => {
    set({ isAuthenticated: false, errorMessage: undefined });
  },

  clearError: () => {
    set({ errorMessage: undefined });
  },
}));

